import React, { Component, Fragment } from "react";
import "./Entryform.css";
import Container from "@material-ui/core/Container";
import subDays from "date-fns/subDays";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import Db from "./db";
import axios from "axios";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { FormGroup, Form } from "reactstrap";
import { DatePicker } from "@material-ui/pickers";
import Typography from "@material-ui/core/Typography";
import * as handler from "../Actions/main";
import { connect } from "react-redux";
class Entryform extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      errorTrainNO: "",
      errordoj: "",
      errorstationCode: "",
      multiple: false,
      options: [],
      isTypeaheadFocus: true,
      trainNO: "",
      doj: new Date(),
      stationCode: "",
      show: false
    };
  }
  componentDidMount() {
    console.log("entryform mounted");
    this.props.resetOutlets();
    this.props.resetOrders();
  }

  _handleSearch = query => {
    this.setState({ isLoading: true });
    axios
      .get(" https://api.confirmtkt.com/api/trains/search", {
        params: { text: query }
      })
      .then(response => {
        const trainP = response.data.map(
          train => train.Key + "/ " + train.Value
        );

        this.setState({
          options: trainP,
          isLoading: false
        });
      })
      .catch(error => {
        this.setState({
          isLoading: true
        });
      });
  };

  handleOnChange = selected => {
    if (selected) {
      let selectedValue = [];
      selectedValue.push(selected);

      this.setState({
        trainNO: selected,
        show: true,
        errorTrainNO: ""
      });
    } else {
      this.setState({
        show: false,
        trainNO: "",
        doj: new Date(),
        stationCode: "",
        errordoj: "",
        errorstationCode: ""
      });
    }
  };

  handleChange = event => {
    this.setState({ stationCode: event.target.value, errorstationCode: "" });
  };

  myChangeHandler = date => {
    // date = this.convert(date);
    this.setState({
      doj: date,
      errordoj: ""
    });
  };

  mySubmitHandler = event => {
    event.preventDefault();
  };

  convert = str => {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [day, mnth, date.getFullYear()].join("-");
  };
  Check = () => {
    if (this.state.trainNO === "") {
      this.setState({
        errorTrainNO: "enter the train name / number"
      });
      return false;
    }

    if (this.state.doj === "") {
      this.setState({
        errordoj: "Please select the date of Journey"
      });
      return false;
    }
    if (this.state.stationCode === "") {
      this.setState({
        errorstationCode: "Please select the Station"
      });
      return false;
    }

    return true;
  };

  formSubmit = () => {
    if (this.Check()) {
      let date = this.convert(this.state.doj);
      this.props.history.push({
        pathname: "/food-booking/outlets",
        search:
          "?trainNO=" +
          this.state.trainNO +
          "&doj=" +
          date +
          "&stationCode=" +
          this.state.stationCode
      });
    }
  };

  render() {
    let placeHolderContent = "TrainNo/ TrainName";
    let minUserAgeDate = subDays(new Date(), 3);
    return (
      <Container maxWidth="sm" style={{ marginTop: "4em" }}>
        <Typography
          align="center"
          variant="h4"
          gutterBottom={true}
          color="primary"
        >
          Order Food In Train
        </Typography>
        <Form onSubmit={this.mySubmitHandler}>
          <FormGroup>
            <div>
              <Grid container justify="flex-start" className="header-summary">
                <Grid item xs={12} className="search-title">
                  {this.props.type}
                </Grid>
              </Grid>

              <div className="search-input">
                <Fragment>
                  <AsyncTypeahead
                    ref={ref => (this._typeahead = ref)}
                    {...this.state}
                    placeholder={placeHolderContent}
                    onSearch={this._handleSearch}
                    maxHeight="350px"
                    style={{ height: 50 }}
                    id="trainlist"
                    onChange={selected => {
                      this.handleOnChange(selected[0]);
                    }}
                  />
                </Fragment>
              </div>
              {this.state.errorTrainNO !== "" ? (
                <p style={{ color: "red", fontSize: "12px" }}>
                  ERROR: {this.state.errorTrainNO}
                </p>
              ) : null}
            </div>
          </FormGroup>
          {this.state.show === true && this.state.isLoading === false ? (
            <div>
              <FormGroup>
                Date of Journey
                <Fragment>
                  <DatePicker
                    autoOk
                    style={{ width: "100%" }}
                    format="dd/MM/yyyy"
                    value={this.state.doj}
                    onChange={this.myChangeHandler}
                    inputVariant="outlined"
                    minDate={minUserAgeDate}
                  />
                </Fragment>
                {this.state.errordoj !== "" ? (
                  <p style={{ color: "red", fontSize: "12px" }}>
                    ERROR: {this.state.errordoj}
                  </p>
                ) : null}
              </FormGroup>

              <Db
                change1={this.myChangeHandler}
                change2={this.handleChange}
                trainNO={this.state.trainNO}
                change3={this.mySubmitHandler}
                errordoj={this.state.errordoj}
                errorstationCode={this.state.errorstationCode}
              />
            </div>
          ) : null}

          <FormGroup>
            <Typography align="center">
              <Button
                variant="contained"
                onClick={this.formSubmit}
                size="medium"
                style={{
                  color: "white",
                  backgroundColor: "green",
                  width: "100%",
                  height: 50
                }}
              >
                Search FOOD
              </Button>
            </Typography>
          </FormGroup>
        </Form>
      </Container>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    resetOutlets: () => dispatch(handler.resetOutlets()),
    resetOrders: () => dispatch(handler.resetRecords())
  };
};
export default connect(
  null,
  mapDispatchToProps
)(Entryform);
